/*
 * @Email: zheniscool@163.com
 * @FilePath: /cbibank-web-corporbank/src/views/outward/api/index.js
 * @Date: 2021-12-20 10:31:16
 * @Author: zhangzhen
 * @LastEditTime: 2021-12-27 11:18:03
 */

import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'

/**
  * 查询收款人名单
  * @param {string} recBankType
  * @param {string} rmtType
  * @param {string} payeeType
  * @param {string} turnPageBeginPos
  * @param {string} turnPageShowNum
  */
export function showCustomerPayeeList (params = {}, config = { convertPageNumAndSize: true }) {
  return api.post(`${NO_PREFIX_URL}/showCustomerPayeeList.do`, params, config, 'URLEncoded')
}

/**
 * 提交行外转账交易
 * @param {string} payAccountName
 * @param {string} payAccountAliasName
 * @param {string} payAddress
 * @param {string} payAccount
 * @param {string} currencyType
 * @param {string} balanceAvailable
 * @param {string} payAmount
 * @param {string} FeeFlg
 * @param {string} chargeFee
 * @param {string} payRemark
 * @param {string} payUse
 * @param {string} addPayBookFlag
 * @param {string} recAccountName
 * @param {string} recAccount
 * @param {string} recCountry
 * @param {string} bankRem
 * @param {string} bankSwift
 * @param {string} recBankName
 * @param {string} recBankCountry
 * @param {string} recBankAddress
 * @param {string} abaCode
 * @param {string} cnapsNo
 * @param {string} bsbNo
 * @param {string} agentRecBankAba
 * @param {string} agentBankSwift
 * @param {string} agentRecBankName
 * @param {string} agentRecBankCountry
 * @param {string} agentRecBankAddress
 * @param {string} logRecordFlag
 * @param {string} file
 * @param {string} recBankType
 * @param {string} rmtType
 * @param {string} tranChannel
 * @param {string} businessCode 10200300
 * @param {string} transferName 跨行转账
 * @param {string} currentBusinessCode: 10200300
 * @param {string} payType
 * @param {string} businessType
 * @param {string} relation
 * @param {string} decAmount
 * @param {string} session_customerId
 */

export function submitOutwardTransferConfirm (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/submitOutwardTransfer_confirm.do`, params, config, 'URLEncoded')
}
